import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../utils/api';

export default function AdminDashboard() {
  const { token, user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.getStats(token).then(d => setStats(d)).catch(() => {});
  }, [token]);

  const tiles = [
    { icon: '🏰', label: 'Eventos', sub: 'Crear y gestionar', path: '/admin/eventos' },
    { icon: '📜', label: 'Reservas', sub: 'Ver y cancelar', path: '/admin/reservas' },
    { icon: '◈', label: 'Usuarios', sub: 'Filtrar por evento', path: '/admin/usuarios' },
    { icon: '⚙', label: 'Perfil', sub: 'Tu cuenta', path: '/perfil' },
  ];

  return (
    <div className="main-content page-enter">
      <div style={{ marginBottom: '1.8rem' }}>
        <div className="section-label">Administración</div>
        <h1>Panel de control</h1>
        <p style={{ color: 'var(--mid)', fontStyle: 'italic', fontSize: '.95rem', marginTop: '.2rem' }}>
          Bienvenido, {user?.familyName || user?.email}
        </p>
      </div>

      <div className="stat-grid">
        {[
          { icon: '◈', val: stats?.totalFamilies ?? '—', lbl: 'Familias' },
          { icon: '🏰', val: stats?.activeEvents ?? '—', lbl: 'Eventos activos' },
          { icon: '📜', val: stats?.totalBookings ?? '—', lbl: 'Reservas' },
          { icon: '⚔', val: stats?.totalParticipants ?? '—', lbl: 'Inscritos' },
        ].map((s, i) => (
          <div className="stat-card" key={i}>
            <div className="stat-icon">{s.icon}</div>
            <div className="stat-val">{s.val}</div>
            <div className="stat-lbl">{s.lbl}</div>
          </div>
        ))}
      </div>

      <div className="section-label" style={{ marginBottom: '.9rem' }}>Accesos rápidos</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '.8rem', maxWidth: 680 }}>
        {tiles.map(t => (
          <div className="card" key={t.path}
            style={{ cursor: 'pointer', padding: '1rem', textAlign: 'center' }}
            onClick={() => navigate(t.path)}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(122,171,138,.1)'}
            onMouseLeave={e => e.currentTarget.style.background = ''}
          >
            <div style={{ fontSize: '1.3rem', marginBottom: '.4rem' }}>{t.icon}</div>
            <div style={{ fontFamily: "'Fraunces',serif", fontSize: '.72rem', fontWeight: 700, color: 'var(--sage)', marginBottom: '.15rem' }}>{t.label}</div>
            <div style={{ fontSize: '.72rem', color: 'var(--mid)', fontStyle: 'italic' }}>{t.sub}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
